/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Card 1: Dynamic Operating Pattern.
 *
 * Steve 2026-06-11 "Dynamic Operating Pattern Prompt Update" replaced the
 * deterministic baseline-plus-modifier generator (DynamicPattern.js) with
 * an AI pass that ships output on aiContent.dynamic_pattern. We prefer
 * that AI output; the static v1.0 dynamic_pattern block on primaryContent
 * remains as a fallback only for old reports generated before the swap.
 */
@Component({
  selector: 'app-dynamic-operating-pattern-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dynamic-operating-pattern-modal.component.html',
})
export class DynamicOperatingPatternModalComponent {
  @Input() primaryContent: any;
  @Input() aiContent: any;

  constructor(public bsModalRef: BsModalRef) {}

  get rows(): { dynamic: string; pattern: string }[] {
    const ai = this.aiContent?.dynamic_pattern || {};
    const fallback = this.primaryContent?.dynamic_pattern || {};
    const pick = (key: 'stress_recovery' | 'motivation_engagement' | 'conflict_style' | 'ideal_projects') =>
      ai[key] || fallback[key] || '';
    return [
      { dynamic: 'Stress & Recovery', pattern: pick('stress_recovery') },
      { dynamic: 'Motivation & Engagement', pattern: pick('motivation_engagement') },
      { dynamic: 'Conflict Style', pattern: pick('conflict_style') },
      { dynamic: 'Ideal Projects', pattern: pick('ideal_projects') },
    ].filter(r => !!r.pattern);
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
